import { ICompany, INetsSettings } from "../models";
import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";

export interface ICompanyService
{
    GetCompany(): Promise<ICompany>;
    UpdateCompany(company: ICompany): Promise<string>;
    GetNetsSettings(): Promise<INetsSettings>;
    UpdateNetsSettings(settings: INetsSettings): Promise<string>;
}

export class CompanyServiceProvider implements ICompanyService
{
    private controller = "api/company";

    public async GetCompany(): Promise<ICompany>
    {
        return await this.get<ICompany>("guild");
    }

    public async UpdateCompany(company: ICompany): Promise<string>
    {
        return await this.patch("guild", company);
    }

    public async GetNetsSettings(): Promise<INetsSettings>
    {
        return await this.get<INetsSettings>("nets");
    }

    public async UpdateNetsSettings(settings: INetsSettings): Promise<string>
    {
        return await this.patch("nets", settings);
    }

    private async get<T>(path: string): Promise<T>
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };

        const response = await AuthenticatedFetch(`${this.controller}/${path}`, requestOptions);
        if(!response.ok)
        {
            throw new Error("Vindmøllelauget blev ikke fundet");
        }

        return await response.json() as T;
    }

    private async patch(path: string, item: object): Promise<string>
    {
        const requestOptions = {
            method: 'PATCH',
            headers: CreateAuthHeader(),
            body: JSON.stringify(item)
        };

        const response = await AuthenticatedFetch(`${this.controller}/${path}`, requestOptions);
        if(response.status === 403)
        {
            return "Du har ikke rettigheder til at gemme ændringerne";
        }

        return await response.text();
    }
}
